import "./PopUp.scss";
import modelOne from "../../images/model1.png";
import modelTwo from "../../images/model2.png";
import modelThree from "../../images/model3.png";
import modelFour from "../../images/model4.png";
import modeFive from "../../images/model5.png";
import modelSix from "../../images/model6.png";
import modelSeven from "../../images/model7.png";
import { simplyClick } from "../../helpers";
import ButtonSubmit from "../buttonSubmit";

const PopUp = ({ step, closePopUp }) => {
  simplyClick("sh_lnd_photos_bnr", { text: `step(${step})` });

  return (
    <div className="pop__up-blur">
      <div className="pop__up-block">
        <span
          onClick={() => {
            closePopUp();
            simplyClick("cl_lnd_photos_bnr_cross", { text: `step(${step})` });
          }}
          className="close"
        />
        <div className="model__block">
          <img src={modelOne} alt="model" />
          <img src={modelTwo} alt="model1" />
          <img src={modelThree} alt="model2" />
          <img src={modelFour} alt="model3" />
          <img src={modeFive} alt="model4" />
          <img src={modelSix} alt="model5" />
          <img src={modelSeven} alt="model6" />
        </div>
        <h2 className="pop__title">Curious and eager for connection? Let’s make it happen!</h2>
        <p className="pop__subtitle">
          Become a member to unlock profiles and start chatting
        </p>

        <ButtonSubmit
          onClick={() => {
            closePopUp();
            simplyClick("cl_lnd_photos_bnr_btn", { text: `step(${step})` });
          }}
          className="button__global button__promo model_popup_button"
          text={"Join now"}
        />
      </div>
    </div>
  );
};
export default PopUp;
